module.exports = __webpack_public_path__ + "img/bg-cant-find.19d8ec8f.jpg";